import { render, staticRenderFns } from "./QualitatPsicomotriuCrud.vue?vue&type=template&id=05240e06&scoped=true&"
import script from "./QualitatPsicomotriuCrud.vue?vue&type=script&lang=js&"
export * from "./QualitatPsicomotriuCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05240e06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
